export const labelInputPlaceholderContent = [
  "A thing happened...",
  "Another thing happened...",
  "A different thing happened...",
  "This one time...",
  "What had happened was...",
];
